enum RegistrationFilter {
  ALL = 'all',
  REGISTERED = 'registered',
  NOT_REGISTERED = 'not_registered',
}

export default RegistrationFilter